export default __webpack_public_path__ + "9ec8fd0.png";